import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icons from '@components/Icons';
import { HelperText, Bold } from '@components/Styled';
import { IconBar, IconCircle, IconWrapper, IconsLine, LabelContent, StepIcon, StepperContent, VerticalLine } from './Stepper.style';
const Stepper = (props) => {
    const { steps, currentStep, verticalOnMobile, isBackgroundWhite } = props;
    const getStatus = (index) => {
        if (index < currentStep)
            return 'completed';
        if (index === currentStep)
            return 'pending';
        return 'inactive';
    };
    const lastStep = steps.length - 1;
    return (_jsx(IconBar, { children: _jsx(StepperContent, { verticalOnMobile: verticalOnMobile, children: steps.map((stepIcon, index) => {
                const hasNextStep = index !== lastStep;
                const status = getStatus(index);
                return (_jsxs(StepIcon, { hasNextStep: hasNextStep, verticalOnMobile: verticalOnMobile, children: [_jsxs(IconsLine, { hasNextStep: hasNextStep, verticalOnMobile: verticalOnMobile, children: [_jsx(IconCircle, { status: status, isBackgroundWhite: isBackgroundWhite, children: _jsx(IconWrapper, { status: status, isBackgroundWhite: isBackgroundWhite, children: status === 'completed'
                                            ? (_jsx("span", { "data-testid": "check-icon", children: _jsx(Icons.Check, { size: "xs" }) }))
                                            : stepIcon.icon }) }), hasNextStep && (_jsx(VerticalLine, { status: status, verticalOnMobile: verticalOnMobile, "data-testid": "verticalLine" }))] }), _jsxs(LabelContent, { hasNextStep: hasNextStep, verticalOnMobile: verticalOnMobile, children: [_jsx(HelperText, { children: _jsx(Bold, { children: stepIcon.label }) }), stepIcon.description && (_jsx(HelperText, { children: stepIcon.description }))] })] }, stepIcon.label));
            }) }) }));
};
export default Stepper;
